import { loanApplicationStages } from "Features/Finance/Helpers/DocKeyNames";
import { atom, useRecoilValue, useSetRecoilState } from "recoil";

export const LoanApplication = atom({
  key: "LoanApplication",
  default: {
    stage: loanApplicationStages.PENDING,
  },
});

export const useLoanApplication = () => {
  const loanApplication = useRecoilValue(LoanApplication);
  const setLoanApplication = useSetRecoilState(LoanApplication);
  return { loanApplication, setLoanApplication };
};
